"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function numberToDoubleN(num, precision) {
    return toDoubleN(to64BitBinaryString(num), precision);
}
exports.numberToDoubleN = numberToDoubleN;
function to64BitBinaryString(num) {
    var numberWriter = new DataView(new ArrayBuffer(8));
    numberWriter.setFloat64(0, num, false);
    var bitStr = "";
    for (var i = 0; i < 8; i++) {
        var bits = numberWriter.getUint8(i).toString(2);
        if (bits.length < 8) {
            var subBits = "";
            for (var j = 0; j < 8 - bits.length; j++) {
                subBits += "0";
            }
            bits = subBits + bits;
        }
        bitStr += bits;
    }
    return bitStr;
}
function toDoubleN(binary, precision) {
    var sign = parseInt(binary[0], 10);
    var exponent = parseInt(binary.substr(1, 11), 2);
    var mantissaStr = binary.substr(12, precision);
    var mantissa = 0;
    for (var i = 0; i < mantissaStr.length; i++) {
        var bin = mantissaStr[i] === "0" ? 0 : 1;
        mantissa += bin * Math.pow(2, -(i + 1));
    }
    return Math.pow(-1, sign) * (1 + mantissa) * Math.pow(2, exponent - 1023);
}
//# sourceMappingURL=doubleN.js.map